<div class="dialog" *ngIf="dialog">
    <div class="dialog-container">
        <div class="dialog-header">
            <h3 class="dialog-title">{{dialog.title}}</h3>
            <button class="dialog-close" (click)="closeDialog()">
                <i class="bi bi-x"></i>
            </button>
        </div>
        <div class="dialog-body">
            <p>{{dialog.message}}</p>
            <input type="text" class="form-control" *ngIf="dialog.input" [(ngModel)]="inputValue">
        </div>
        <div class="dialog-footer">
            <button class="btn btn-outline-primary" *ngIf="dialog.button1Text" (click)="dialog.input ? dialog.button1Callback(inputValue) : dialog.button1Callback()">{{dialog.button1Text}}</button>
            <button class="btn btn-primary" *ngIf="dialog.button2Text" (click)="dialog.input ? dialog.button2Callback(inputValue) : dialog.button2Callback()">{{dialog.button2Text}}</button>
        </div>
    </div>
</div>